import { Slider } from "./ui/slider";

const fmt = (n) => `$${Math.round(n || 0).toLocaleString()}`;

export const CarTermSlider = ({ term, onChange, rows }) => {
  const cheapest = rows.reduce((m, r) => (r.chosen_monthly > 0 && (!m || r.chosen_monthly < m.chosen_monthly) ? r : m), null);
  return (
    <div className="bg-white border border-gray-200 rounded-2xl p-5" data-testid="car-term-slider-card">
      <div className="flex items-baseline justify-between gap-3 mb-1">
        <h3 className="font-bold text-[#2D3748]">Try a different loan term</h3>
        <span className="text-2xl font-bold text-[#3E9690]" data-testid="car-term-value">{term} yrs</span>
      </div>
      <p className="text-xs text-gray-500 mb-4">Slide to see every bank's monthly payment change. Banks can't go past their own max term.</p>
      <Slider
        min={3}
        max={9}
        step={1}
        value={[term]}
        onValueChange={(v) => onChange(v[0])}
        data-testid="car-term-slider"
      />
      <div className="flex justify-between text-[11px] text-gray-400 mt-2">
        <span>3 yrs</span><span>9 yrs</span>
      </div>
      {cheapest && (
        <p className="text-sm text-gray-700 mt-3" data-testid="car-term-best">
          Lowest at {term} yrs: <strong className="text-[#3E9690]">{fmt(cheapest.chosen_monthly)}/mo</strong> with {cheapest.bank_name}
          {cheapest.capped ? ` (${cheapest.chosen_years}-yr max)` : ""}
        </p>
      )}
    </div>
  );
};
